/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import clsx from 'clsx';
import notification from 'epn-ui/umd/dist/components/Notification';
import CopyInput from 'epn-ui/umd/dist/components/CopyInput';

import useI18n from '@i18n';

import copyTextToClipboard from '@utils/clipboard';

interface ICopyableLinkProps {
    label: string;
    text: string;
    id?: string;
    description?: string;
}

const BaseCopyableLink: React.FC<ICopyableLinkProps> = ({
    label,
    text,
    id = text,
    description,
}) => {
    const { t } = useI18n();

    const onCopyHandler = async (): Promise<void> => {
        if (typeof text !== 'string' || text.length === 0) return;
        await copyTextToClipboard(text);
        notification.success({
            message: t('Copied'),
        });
    };

    return (
        <div className="flex flex-col">
            {description && (
                <div className="flex justify-between">
                    <span className="mb-2 text-p3 text-blueGray-500">{label}</span>
                    <span className="mb-2 text-p3 text-blueGray-500">{description}</span>
                </div>
            )}
            {!description && <span className="mb-2 text-p3 text-blueGray-500">{label}</span>}
            <div
                id={id}
                className={clsx('relative', { 'pointer-events-none': !text?.length })}
                role="button"
                onClick={onCopyHandler}
            >
                <CopyInput
                    className="w-full pl-3 pr-6 outline-none cursor-pointer bg-blueGray-100 text-blueGray-500 py-[9px]"
                    value={text}
                />
            </div>
        </div>
    );
};

export default BaseCopyableLink;
